module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst doc = model.document || {}\n%><div><%\nif(doc.url){\n%><a href=\"<%= doc.url %>\" target=\"_blank\"><%\n%><img src=\"<%- doc.QRCodeWeb %>\" alt=\"web\" title=\"web\" /><%\n%></a><%\n%><a class=\"qr pdf\" href=\"<%= doc.url %>.pdf\" target=\"_blank\">\n%><img src=\"<%- doc.QRCodePDF %>\" alt=\"pdf\" title=\"pdf\" /><%\n%></a><%\n}\n%></div>"
  , __filename = "components/templates/core/documents/qrCodes/qrCodes.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const doc = model.document || {}

    ; __line = 3
    ; __append("<div>")
    ; 
if(doc.url){

    ; __line = 5
    ; __append("<a href=\"")
    ; __append(escapeFn( doc.url ))
    ; __append("\" target=\"_blank\">")
    ; 

    ; __line = 6
    ; __append("<img src=\"")
    ; __append( doc.QRCodeWeb )
    ; __append("\" alt=\"web\" title=\"web\" />")
    ; 

    ; __line = 7
    ; __append("</a>")
    ; 

    ; __line = 8
    ; __append("<a class=\"qr pdf\" href=\"")
    ; __append(escapeFn( doc.url ))
    ; __append(".pdf\" target=\"_blank\">\n")
    ; __line = 9
    ; __append("<img src=\"")
    ; __append( doc.QRCodePDF )
    ; __append("\" alt=\"pdf\" title=\"pdf\" />")
    ; 

    ; __line = 10
    ; __append("</a>")
    ; 
}

    ; __line = 12
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/qrCodes/qrCodes.ejs

}